import planBase from "./planBase.js";
import imageFormat from "../../definition/imageFormat.js";
import filterBase from "./filter/filterBase.js";

export default class ImagePlan extends planBase {
    objectType = "ImagePlanItem";
    styleColor = 'rgb(87, 78, 0)'; // Gris foncé

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
    }

    static get Name() {
        return "Image Plan";
    }

    get addedElementShortCutAction() {
        return [
            ...super.addedElementShortCutAction,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "image", description: "Changer l'image", svgComponentIcon: "imageCarouselIcon" },
        ];
    }
    get shortCut() {
        return [
            ...super.shortCut,
            { name: "Path", type: "pathInput", dataType: "string", ressourceType: "image", description: "Changer l'image", svgComponentIcon: "imageCarouselIcon" },
        ];
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Path", text: "Image", type: "pathInput", dataType: "string", ressourceType: "image" },
            { name: "Format", text: "Format", type: "selectInput", dataType: "number", options: imageFormat, optionsType: "idSoft" },
            //{ name: "Filters", text: "Filtres", type: "selectInput", dataType: "string", options: filters, optionsType: "idSoft", multiple: true, tooltip: "Filtres à appliquer à la photo, l'ordre des filtres peut changer le rendu de la photo" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput"),
            { name: "Filters", text: "Filtres", type: "arrayInput", dataType: "object", options: filterBase, elementOption: "compositionElement", label: "Ajouter un filtre à ", elements: { name: "Filters", type: "objectInput", dataType: "object", options: filterBase } },
        ];
    }

    async getStyleAsync(currentElementIndex = null, force = false) {
        let style = {
            ...super.getStyle(currentElementIndex),
            backgroundImage: `url(${await this.getFilteredPathAsync(null, force)})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            position: 'absolute',
        }
        const format = imageFormat.find(format => format.idSoft == this.Format);
        if (format) {
            style = format.action(style);
        }
        else {
            style.backgroundSize = 'cover';
        }
        return style;
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            format: this.FormatName,
            path: "@" + this._Path + "@",
            filters: this.Filters.map(filter => filter.toExportObject(variableArray, ressourceArray)),
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            format: this.FormatName,
            path: this.Path,
            filters: this.Filters.map(filter => filter.toObject(minify)),
        };
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Filters", construct: Array, jsType: "Array" },
            { property: "_Path", construct: String, jsType: "String", isRessource: true },
            { property: "Format", construct: Number, jsType: "Number" },
        ];
    }
}
